// extracted by mini-css-extract-plugin
export default {"card":"warning-card_card__wlRQL"};